export class SeedingComment {
    _id = '';
    target_link='';
    isLike = false;
    reaction=Array();
    time_before_like_from = 2;
    time_before_like_to = 10;
    time_after_like_from = 2;
    time_after_like_to = 10;
    isComment = false;
    content_comments = Array();
    time_before_comment_from = 2;
    time_before_comment_to = 10;
    time_after_content_comment_from = 2;
    time_after_content_comment_to = 10;
    time_after_comment_from = 2;
    time_after_comment_to = 10;
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/auto_seeding/seeding_comment.ts